import { Component, OnInit, Input } from '@angular/core';

@Component({
   selector: 'pasqua-app-header',
   templateUrl: './app-header.component.html',
   styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {
   @Input("titolo") titoloApplicazione: String;
   @Input("facebookUrl") facebookUrl: String;
   @Input("twitterUrl") twitterUrl: String;
   @Input("linkedinUrl") linkedinUrl: String;
   
   constructor() { }

   ngOnInit(): void {
   }

}
